export const CONTACT_VERIFICATION_CODE_SOURCE =
    "WAGS-[0-9A-HJKMNP-TV-Z]{4}-[0-9A-HJKMNP-TV-Z]{4}";
export const LEGACY_CONTACT_TOKEN_SOURCE = "[A-HJ-NP-Z2-9]{6}";
const CONTACT_TOKEN_SHAPED_PATH = new RegExp(
    `/([ck])/(?:${CONTACT_VERIFICATION_CODE_SOURCE}|${LEGACY_CONTACT_TOKEN_SOURCE}(?![0-9A-Z]))`,
    "giu",
);
const BARE_VERIFICATION_CODE = new RegExp(
    `\\b${CONTACT_VERIFICATION_CODE_SOURCE}\\b`,
    "giu",
);
const BRACKETED_LEGACY_CODE = new RegExp(
    `\\[${LEGACY_CONTACT_TOKEN_SOURCE}\\]`,
    "giu",
);
const MIGHT_HOLD_TOKEN = /[%/[]|wags-/iu;
const MAX_SCRUB_DEPTH = 16;
const CIRCULAR = "[Circular]";

export function decodeAsciiEscapes(value) {
    return value.replace(/%([0-7][0-9a-f])/giu, (_, hex) =>
        String.fromCharCode(Number.parseInt(hex, 16)),
    );
}

export function redactContactTokens(
    value,
    tokenPath = CONTACT_TOKEN_SHAPED_PATH,
) {
    if (!MIGHT_HOLD_TOKEN.test(value)) return value;
    const decoded = value.includes("%") ? decodeAsciiEscapes(value) : value;
    const redacted = decoded
        .replace(tokenPath, (_, kind) => `/${kind.toLowerCase()}/:token`)
        .replace(BARE_VERIFICATION_CODE, "[redacted]")
        .replace(BRACKETED_LEGACY_CODE, "[[redacted]]");
    return redacted === decoded ? value : redacted;
}

function isScrubbableContainer(value) {
    if (Array.isArray(value)) return true;
    const prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
}

function scrubValue(value, depth, scrubbed, active) {
    if (typeof value === "string") return redactContactTokens(value);
    if (
        typeof value !== "object" ||
        value === null ||
        depth > MAX_SCRUB_DEPTH ||
        !isScrubbableContainer(value)
    ) {
        return value;
    }
    if (scrubbed.has(value)) return scrubbed.get(value);
    if (active.has(value)) return CIRCULAR;
    active.add(value);
    let copy = null;
    for (const [key, child] of Object.entries(value)) {
        const next = scrubValue(child, depth + 1, scrubbed, active);
        if (next === child) continue;
        copy ??= Array.isArray(value) ? [...value] : { ...value };
        copy[key] = next;
    }
    active.delete(value);
    const result = copy ?? value;
    scrubbed.set(value, result);
    return result;
}

export function scrubContactTokens(value) {
    return scrubValue(value, 0, new WeakMap(), new WeakSet());
}
